import React from "react";
import BaseModal from "../../components/BaseModal";
import useModalActions from "../../hooks/useModalActions";
import BaseButton from "../../components/BaseButton";
import { MODAL_TYPES } from "../../utils/emitter";
import TextHelpList from "../../components/TextHelpList";
import "./style.scss";
import { useTranslation } from "react-i18next";

export default function HelpCompromiseModal() {
  const { closeModal } = useModalActions();
  const { t } = useTranslation();
  return (
    <BaseModal
      className="big-mobile-modal"
      eventTypeModal={MODAL_TYPES.HELP_COMPROMISE}
      title={t("modals.help_compromise.title")}
      description={<TextHelpList />}
      contentStyle="compromise-content-modal"
    >
      <BaseButton onClick={() => closeModal(MODAL_TYPES.HELP_COMPROMISE)}>
        {t("modals.help_compromise.agree")}
      </BaseButton>
    </BaseModal>
  );
}
